import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedRole: "admin", // default role
};

const adminRoleSlice = createSlice({
  name: "adminRole",
  initialState,
  reducers: {
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
  },
});

export const { setSelectedRole } = adminRoleSlice.actions;
export default adminRoleSlice.reducer;
